import Box from "@mui/material/Box";
import {
  Button,
  Grid,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
  Typography,
  Switch
} from "@mui/material";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import PageTitle from "../../Components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function CalendarioUpdate() {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(6); //Jornadas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();
  const navigate = useNavigate();
  const { idCalendar } = useParams();

  const [diaSemana, setDiaSemana] = useState([
    {
      dia: 1,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 2,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 3,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 4,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 5,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 6,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
    {
      dia: 7,
      minutos: 0,
      horaIniP1: null,
      horaFimP1: null,
      horaIniP2: null,
      horaFimP2: null,
    },
  ]);

  const [semana, setSemana] = useState([
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sabado",
  ]);

  const [formData, setFormData] = useState({
    idEmpresa: 0,
    descricao: "",
    status: "A",
    dias: diaSemana,
  });

  //Consultar Calendários
  const fetchCalendar = async () => {
    setAvisoErro("");
    setLoading(true);
    setAvisoSucesso("");

    const response = await GetAPI(apiAxios, `/calendario/${idCalendar}`);

    setLoading(false);

    if (response.success) {
      const newDias = response.data.dias;

      newDias.map((antigo) => {
        diaSemana.map((novo) => {
          if (novo.dia === antigo.dia) {
            novo.horaIniP1 = antigo.horaIniP1;
            novo.horaFimP1 = antigo.horaFimP1;
            novo.horaIniP2 = antigo.horaIniP2;
            novo.horaFimP2 = antigo.horaFimP2;
            novo.minutos = antigo.minutos;
          }
        });
      });

      setFormData({
        id: idCalendar,
        idEmpresa: response.data.idEmpresa,
        descricao: response.data.descricao,
        status: response.data.status,
        dias: diaSemana,
      });
    } else {
      setAvisoErro("Erro ao buscar dados do calendário.");
    }
  };

  useEffect(() => {
    // Função para buscar dados da API
    fetchCalendar();
  }, []);

  const handleVoltar = () => {
    navigate("/jornadas");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeDias = (index, field, value) => {
    const newDias = [...diaSemana];
    newDias[index][field] = value;
    setDiaSemana(newDias);
  };

  const handleCopyDias = (index) => {
    const newDias = [...diaSemana];

    newDias.map((reg) => {
      if (reg.dia > 2 && reg.dia < 7) {
        reg.horaIniP1 = diaSemana[index].horaIniP1;
        reg.horaFimP1 = diaSemana[index].horaFimP1;
        reg.horaIniP2 = diaSemana[index].horaIniP2;
        reg.horaFimP2 = diaSemana[index].horaFimP2;
        reg.minutos = diaSemana[index].minutos;
      }
    });

    setDiaSemana(newDias);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setAvisoErro("");
    setAvisoSucesso("");

    const response = await PostAPI(apiAxios, "/calendario", formData);

    setLoading(false);

    // Se a requisição for bem-sucedida, limpa os campos do formulário e exibe sucesso.
    if (response.success) {
      setAvisoSucesso("Jornada atualizada com sucesso!");
    } else {
      setAvisoErro(
        response.errorMessage || "Erro ao atualizar jornada. Tente novamente.",
      );
    }
  };

  const handleStatus = () => {
    const fnc = formData.status;
     setFormData((prevData) => ({
      ...prevData,
      status: fnc === "A" ? "I" : "A",
    }));
  }

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Alterar Jornada de Trabalho"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          padding: 2,
          gap: 2,
          backgroundColor: "transparent",
          borderRadius: 1,
        }}
      >
        <Grid container>
          <Grid item xs={12} md={11} mb={3}>
            {/* Campos de texto para entrada de dados do formulário */}
            <TextField
              label="Descrição"
              name="descricao"
              type="text"
              value={formData.descricao}
              onChange={handleChange}
              required
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={1} mb={3}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid #c4c4c4",
              borderRadius: "4px",
              padding: "10px 12px",
              height: "56px",
              width: "100%",
              position: "relative",
            }}
          >
            <Typography
              sx={{
                position: "absolute",
                top: "-10px",
                left: "10px",
                backgroundColor: "#fff",
                padding: "0 5px",
                fontSize: "12px",
                color: "#6c6c6c",
              }}
            >
              Ativo
            </Typography>
            <Switch
              checked={(formData.status ?? "") === "A"}
              name="status"
              color="warning"
              size="small"
              onClick={handleStatus}
            />
          </Box>
        </Grid>

          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: "#ffffffff", padding: "6px" }}>
                <TableRow sx={{ borderBottom: "none" }}>
                  <TableCell
                    align="center"
                    rowSpan={2}
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Dia
                  </TableCell>
                  <TableCell
                    align="center"
                    colSpan={2}
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Período 1
                  </TableCell>
                  <TableCell
                    align="center"
                    colSpan={2}
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Período 2
                  </TableCell>
                  <TableCell
                    align="center"
                    rowSpan={2}
                    sx={{
                      borderBottom: "none",
                      padding: "6px",
                      width: "170px",
                    }}
                  >
                    Minutos
                  </TableCell>
                </TableRow>
                <TableRow sx={{ borderBottom: "none" }}>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Entrada
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Saída
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Entrada
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderBottom: "none", padding: "6px" }}
                  >
                    Saída
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {diaSemana.map((reg, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{semana[reg.dia - 1]}</TableCell>
                    <TableCell align="center">
                      <TextField
                        type="time"
                        value={reg.horaIniP1}
                        onChange={(e) =>
                          handleChangeDias(index, "horaIniP1", e.target.value)
                        }
                        fullWidth
                        size="small"
                        inputProps={{
                          step: 1,
                          style: { textAlign: "center" }, // Centraliza o texto
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        type="time"
                        value={reg.horaFimP1}
                        onChange={(e) =>
                          handleChangeDias(index, "horaFimP1", e.target.value)
                        }
                        fullWidth
                        size="small"
                        inputProps={{
                          step: 1,
                          style: { textAlign: "center" }, // Centraliza o texto
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        type="time"
                        value={reg.horaIniP2}
                        onChange={(e) =>
                          handleChangeDias(index, "horaIniP2", e.target.value)
                        }
                        fullWidth
                        size="small"
                        inputProps={{
                          step: 1,
                          style: { textAlign: "center" }, // Centraliza o texto
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        type="time"
                        value={reg.horaFimP2}
                        onChange={(e) =>
                          handleChangeDias(index, "horaFimP2", e.target.value)
                        }
                        fullWidth
                        size="small"
                        inputProps={{
                          step: 1,
                          style: { textAlign: "center" }, // Centraliza o texto
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Box display={"flex"} alignItems={"center"}>
                        <TextField
                          type="number"
                          value={reg.minutos}
                          onChange={(e) =>
                            handleChangeDias(index, "minutos", e.target.value)
                          }
                          fullWidth
                          size="small"
                          inputProps={{
                            style: { textAlign: "center" },
                          }}
                        />
                        {index === 1 && (
                          <Tooltip title="Copiar para outros dias">
                            <RestartAltIcon
                              size="small"
                              color="primary"
                              onClick={(e) => handleCopyDias(index)}
                            />
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Botão de envio que muda de estilo quando em estado de sucesso ou carregando */}
          <Grid container spacing={2}>
            <Grid
            item
            xs={12}
            md={12}
            sx={{
              display: "flex",
              justifyContent: "space-between", // separa esquerda e direita
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              mt: 2,
            }}
          >
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  backgroundColor: "#1a3865",
                  marginLeft: 2,
                }}
                onClick={handleSubmit}
                type="submit"
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
